import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { addData } from '../../helpers/fackBackend_Helper';

function* getShortCodeDataResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, '/shortCode', data);
        if (response.response.Status) {
            yield put(
                actions.getShortCodeSuccess(
                    response.response.Data
                ));
        } else {
            yield put(actions.getShortCodeFailed(response.response.Message));
        }
    } catch (error) {
        yield put(actions.getShortCodeFailed(error));
    }
}

function* getSimTypeDataResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, '/shortCode', data);
        if (response.response.Status) {
            yield put(actions.getSimTypeSuccess(response.response.Data));
        } else {
            yield put(actions.getSimTypeFailed(response.response.Message));
        }
    } catch (error) {
        yield put(actions.getSimTypeFailed(error));
    }
}


export default function* rootSaga() {
    yield all([takeEvery(actions.GET_SHORT_CODE, getShortCodeDataResponse)]);
    yield all([takeEvery(actions.GET_SIM_TYPE, getSimTypeDataResponse)]);
}
